const { GraphQLClient } = require("graphql-request")

// const { Headers } = require("cross-fetch")
// global.Headers = global.Headers || Headers

const request = async ({ query, variables }) => {
  const endpoint =
    process.env.NEXT_PUBLIC_DATOCMS_API_ENDPOINT ||
    "https://graphql.datocms.com/preview"

  const client = new GraphQLClient(endpoint, {
    headers: {
      Authorization: `Bearer ${process.env.NEXT_PUBLIC_DATOCMS_API_TOKEN}`,
    },
  })

  return client.request(query, variables)
}

module.exports = { request }
